import React, { useContext, useEffect, useState } from "react";
import AdminContext from "../../../StateContext/Application";
import { Form, Link, useNavigate } from "react-router-dom";
import { apiurl } from "../../../../../path";
const TenderCancelRefund = () => {
  const data = useContext(AdminContext);
  const { EcsRefund, CompleteRefundProcess } = data;
  const [Auction, SetAuction] = useState([]);
  const Navigate = useNavigate();
  const [searchdata, SetSearchData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Auction.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
    try {
      getdata();
    } catch (error) {
      console.error(error);
    }
  }, []);

  const getdata = async () => {
    try {
      let a = await EcsRefund('TenderCancelRefund');
      console.log("a",a);
      
      SetSearchData(a);
      SetAuction(a);
    } catch (error) {
      console.error(error);
    }
  };

  const CompleteRefund = async (id) => {
    try {
      let Process = await CompleteRefundProcess(id);
      if (Process) {
        alert("Refund Completed");
      } else {
        alert("failed");
      }
    } catch (error) {
      console.error(error);
    }
  };
  const Search = async (e) => {
    try {
      let searchvalue = e.currentTarget.value.toLowerCase();
      if (!searchvalue) {
        SetAuction(searchdata); // If search value is empty, show all data
        return;
      }
      let data = Auction.filter((x) => {
        return (
          x.Tender_Name.toLowerCase().includes(searchvalue) ||
          x.PO_Number.toLowerCase().includes(searchvalue)
        );
      });
      SetAuction(data);
    } catch (error) {
      console.error(error);
    }
  };

  const paginate = async (e)=>{
    
  }

  return (
    <div style={{ backgroundColor: "#f6f8fc", height: "100%" }}>
      <div style={{ display: "flex", flexWrap: "wrap", width: "100%" }}>
        <div
          className="my-3 mx-3 form-control"
          style={{
            textAlign: "center",
            padding: "1rem 5rem 0 5rem",
            backgroundColor: "white",
            height: "7rem",
          }}
        >
          <label>
            <b>Tender Cancel Refund</b>
          </label>
          <input
            type="search"
            className="form-control my-2"
            onChange={(e) => Search(e)}
            placeholder="Search by Name/PO Number"
            style={{ border: "1px solid orange" }}
          ></input>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          width: "100%",
          justifyContent: "center",
        }}
      >
        {currentItems?.map((auction) => (
          <>
            <div class="card mb-3 my-3 mx-3 form-control">
              <div class="row g-0">
                <div class="col-md-5" style={{ display: "flex" }}>
                  <span>
                    <img
                      className="hovereffect"
                      style={{
                        padding: "0",
                        height: "100%",
                        width: "6rem",
                        borderRadius: "6rem",
                      }}
                      src={
                        auction.Tender_Picture
                          ? `${apiurl}/AuctionDetailsget/${auction.Tender_Picture}`
                          : "https://www.the-sustainable-fashion-collective.com/img/http/assets.the-sustainable-fashion-collective.com/assets/the-swatch-book/2014/11/cotton.png/7c098280951a28c0f2aa4291f179ae42.png"
                      }
                      alt="..."
                    />
                  </span>
                  <span>
                    <h5 class="mx-5">{auction.Tender_Name}</h5>
                    <p class="card-text mx-5" style={{ color: "#e73d26" }}>
                      <b>{auction.Tender_ID}</b>
                    </p>
                    <p class="card-text mx-5">
                      <b>Winner Of Tender({auction.TenderWinnerName})</b>
                    </p>
                  </span>
                </div>
                <div class="col my-4 d-flex">
                  <Link
                    to={
                      "/AdminDashboard/GenerateTenderCancelRefund/" +
                      auction.Tender_ID +
                      "/" +
                      auction.Tender_Name
                    }
                  >
                    <button
                      className="btn btn-success mx-5 hovereffect"
                      style={{
                        backgroundColor: "rgb(10, 200, 150) ",
                        border: "none",
                        borderRadius: "10px",
                      }}
                    >
                      GenerateRefund
                    </button>
                  </Link>
                  {/* <div>
                    <button
                      className="btn btn-danger hovereffect"
                      style={{
                        backgroundColor: "rgb(10, 200, 150) ",
                        border: "none",
                        borderRadius: "10px",
                      }}
                      onClick={() => CompleteRefund(auction.Tender_ID)}
                    >
                      Complete Refund Process
                    </button>
                  </div> */}
                </div>
              </div>
            </div>
          </>
        ))}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <ul className="pagination">
            {Array(Math.ceil(Auction.length / itemsPerPage))
              .fill()
              .map((_, index) => (
                <li key={index} className="page-item">
                  <button
                    onClick={() => paginate(index + 1)}
                    className="page-link"
                  >
                    {index + 1}
                  </button>
                </li>
              ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TenderCancelRefund
